import React, { useReducer, useContext, createContext } from "react";

const initialState = {
  vat: "",
};

export const SYSTEM_ACTIONS = {
  SET_VAT: "SET_VAT"
};

const reducer = (state, action) => {
  switch (action.type) {
    case SYSTEM_ACTIONS.SET_VAT:
      return {
        ...state,
        vat: action.payload
      };

    default:
      return state;
  }
};

const SystemContext = createContext(initialState);

export default function SystemProvider({ children }) {
  return (
    <SystemContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </SystemContext.Provider>
  );
}

export const useSystemContext = () => useContext(SystemContext);
